import * as t from 'io-ts';

import {TrueAvailabilityStatusesEnum} from '../../../../helpers/models/schedulingLinkAvailabilityHelpers';
import {makeEnumRuntimeType} from '../../../../models/api/apiTypes';
import {RDraftSchedulingLink} from '../../../../models/api/schedulingLinkModel';
import {RAsyncStatus} from '../../../appTypes';

/*
 * Runtime types.
 */

export const RCalendarsPanelSchedulingState = t.type({
  trueAvailabilityStatus: makeEnumRuntimeType(TrueAvailabilityStatusesEnum),
  draftLink: RDraftSchedulingLink,
  organizerAddress: t.string,
  didEditDraft: t.boolean,
  status: RAsyncStatus,
});

/*
 * Types.
 */

export interface CalendarsPanelSchedulingState
  extends Readonly<t.TypeOf<typeof RCalendarsPanelSchedulingState>> {}
